import { render, staticRenderFns } from "./FaqQuestionAnswer.vue?vue&type=template&id=a1a0563c&"
import script from "./FaqQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./FaqQuestionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./FaqQuestionAnswer.vue?vue&type=style&index=0&id=a1a0563c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports